import './scss/about.scss'

import AboutComponent from './AboutComponent'

const AboutPackage = {
    name: 'about',
    configure: function(config) {
        const aboutVersion = "The Writer"

        config.addPopover(
            'npwriterabout',
            {
                icon: '/assets/icon.svg',
                align: 'left',
                css: {
                    width: '20px',
                    height: '24px'
                }
            },
            AboutComponent
        )

        config.addLabel('about-header', {
            en: aboutVersion,
            sv: aboutVersion,
            nl: aboutVersion,
            fi: aboutVersion,
            no: aboutVersion,
            dk: aboutVersion
        })

        config.addLabel('About', {
            'sv': 'Om'
        })

        config.addLabel('Settings', {
            'sv': 'Inställningar'
        })

        config.addLabel('The Writer is brought to you by Infomaker Scandinavia AB and was first released in early 2016.', {
            sv: "Infomakers digitala Writer, skapad av Infomaker Scandinavia AB och släpptes första gången våren 2016."
        })

        config.addLabel('Core team and credits', {
            sv: "Utvecklingsteam och credits",
        })
    }
}

export {AboutPackage}
